export const SharedUrls = {
  GET_COUNTRIES: "/shared/country_list",
  BILLING_DETAILS: "/coach/billing-details",
};
